import { useCallback, useEffect, useState } from "react";
import { localDateTime } from "../../lib/datetime";
import { useTranslation } from "react-i18next";
import { DatabaseBackup, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { NeuButton, NeuCard } from "../../components/neu/Neu";
import { listBackups, runBackup } from "../../api/backups";
import { downloadBackup } from "./BackupRow";
import { BackupUpload } from "./BackupUpload";

// نسخة احتياطية كاملة لبيانات الشركة: زر إنشاء (ينزّل الملف فوراً) وزر رفع للإصلاح.
export const CompanyBackupCard = () => {
  const { t } = useTranslation();
  const [latest, setLatest] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    try {
      setLatest((await listBackups()).backups?.[0] || null);
    } catch {
      setLatest(null);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const run = async () => {
    setBusy(true);
    try {
      const res = await runBackup();
      toast.success(t("backups.created", { records: res.records }));
      await downloadBackup(res, t); // ينزّل الملف فوراً ويخبر المستخدم بمكان الحفظ
      await load();
    } catch (error) {
      toast.error(t(error?.response?.status === 503 ? "backups.noStorage" : "errors.generic"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <NeuCard data-testid="company-backup-card">
      <div className="flex items-start justify-between gap-3">
        <p className="label-xs">{t("backups.title")}</p>
        <DatabaseBackup className="h-5 w-5 text-primary" />
      </div>
      <p className="mt-3 text-xs leading-6 text-muted-foreground">{t("backups.hint")}</p>
      {latest ? (
        <p className="mt-3 flex items-center gap-2 text-xs font-bold text-primary num" data-testid="backup-latest">
          <ShieldCheck className="h-4 w-4 shrink-0" />
          {t("backups.latest", {
            when: localDateTime(latest.at),
            records: latest.records,
          })}
        </p>
      ) : (
        <p className="mt-3 text-xs text-muted-foreground" data-testid="backup-empty">
          {t("backups.empty")}
        </p>
      )}
      <div className="grid gap-2 sm:flex sm:flex-wrap sm:items-center">
        <NeuButton
          variant="primary"
          className="mt-3 w-full justify-center py-3 sm:w-auto sm:px-6"
          data-testid="backup-run-btn"
          disabled={busy}
          onClick={run}
        >
          {busy ? t("backups.busy") : t("backups.action")}
        </NeuButton>
        <BackupUpload onDone={load} />
      </div>
    </NeuCard>
  );
};
